import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-studytogether',
  templateUrl: './studytogether.component.html',
  styleUrls: ['./studytogether.component.css']
})
export class StudytogetherComponent implements OnInit {

  constructor() { }
  currentYear: number = new Date().getFullYear();

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/studytogether/studytogether.component.ts